
import "@fancyapps/ui/dist/carousel/carousel.css"


import { mapActions, mapGetters, mapMutations } from "vuex"
export default {
	data() {
		return {
			isInit: false,
			sl: null,
			sl__mini: null
		}
	},
	props: {

		url: String,
		offer: {
			type: Object | null,
			default: null
		},
		noButton: {
			type: Boolean,
			default: false
		},
		noVin: {
			type: Boolean,
			default: false
		},

		activeFancybox: {
			type: Boolean,
			default: false
		},
		modal: {
			type: Boolean,
			default: false
		},
		callback: {
			type: Boolean,
			default: false
		},
		inStock: {
			type: Boolean,
			default: false
		},
		isNewCar:{
			type: Boolean,
			default: false
   		},
		tag:{
			type:String,
			default: ''
		}
	},
	computed: {
		...mapGetters({
			likesArray: 'favorite/favorite/likesArray',
			currentCar: 'modal/modal-choose/currentCar',
			settings: 'settings/settings/settings',
			storeOffer: 'catalog/catalog-cars/offer',
			isNight: "settings/settings/isNight"

		}),
		currentOffer() {
			return this.offer ? this.offer : storeOffer
		},
		device() {
			return this.$device.isMobile ? this.$device.isMobile : false
		},
		currentOffer() {
			return this.offer
		},

	},
	methods: {
		...mapActions({
			liked: 'favorite/favorite/liked',
			openModal: 'modal/modal-main/openModal',
			closeModal: 'modal/modal-main/closeModal',

		}),
		...mapMutations({
			setCarPageLoaded: 'catalog/catalog-cars/SET_CAR_PAGE_LOADED',
			setOffer: 'catalog/catalog-cars/SET_OFFER',

		}),
		async callbackFunc() {
			let payload = {
				modal_component: 'modal-callback-main',
			}
			await this.openModal(payload)
		},
		async like() {
			await this.liked(this.offer.external_id)
		},
		async autoteka(carInfo) {

			let payload = {
				modal_data: carInfo,
				modal_component: 'modal-autoteka',
				modal_title: 'Отчет от ' + carInfo.createdAt,
				modal_sub_title: carInfo.name
			}
			this.openModal(payload)
		},

	},

	// mounted() {
	// 	if (this.activeFancybox)
	// 		Fancybox.bind(`[data-fancybox="gallery-${this.offer.id}${this.modal ? `-modal` : ''}"]`, {
	// 			groupAll: true,
	// 			compact: this.$device.isMobile ? true : false

	// 		})
	// 	// Initialise Carousel
	// 	// this.initSliders()

	// },
	// watch: {
	// 	offer() {
	// 		if (this.activeFancybox)
	// 			Fancybox.bind(`[data-fancybox="gallery-${this.offer.id}${this.modal ? `-modal` : ''}"]`, {
	// 				groupAll: true,
	// 				compact: this.$device.isMobile ? true : false

	// 			})
	// 	}
	// }
	// unmounted() {
	// 	this.setOffer(null)
	// }
}
